<template>
<div>
  <div class="header">
    <img class="logo" src="../../public/image/index/216.png">
    <div class="header-content">
      <div class="header-title">CC加速器</div>
      <div class="header-describe">免费 稳定 极速</div>
    </div>
    <img class="header-download"  src="../../public/image/index/98.png" @click="downloadAPK">
  </div>
  <div class="navigation">
    <img @click="historyGo" class="navigation-img" src="../../public/image/index/99.png">
    <div class="navigation-txt">华为鸿蒙系统安装游戏教程</div>
  </div>
  <div class="principal">
    <div class="principal_content matter">近期华为手机鸿蒙系统上线了！随之上线的还有专属的纯净模式，当开启这个模式，CC加速器中所有应用和游戏必须从华为应用商城安装。那么华为手机鸿蒙系统纯净模式下怎么使用CC加速器下载安装游戏呢？首先是要关闭鸿蒙系统的纯净模式，否则是无法正常安装。为此，CC小编特地给大家整理了一篇详细的关闭纯净模式教程让你畅玩全球游戏，一起来看看！</div>

    <div class="principal-headline2 headline" @click="openOfficial">点击打开官网下载最新版本CC加速器</div>
    <img class="principal-img-1" src="../../public/image/index/97.png">

    <div class="principal_content">点击【立即下载】下载CC加速器最新版本安装包下载好CC加速器后系统进入应用安装界面，请点击【继续安装】</div>
    <img class="principal-img-1" src="../../public/image/index/90.png">

    <div class="principal_content">安装好CC加速器最新版本，由于在纯净模式下CC加速器下载的游戏均无法进行安装，需关闭纯净模式。下面提供两种方法关闭纯净模式，以安装【虫虫助手】为例：</div>
    <div class="principal_content step headline"><span class="principal_content-blue">【方法1】</span>1.进入手机设置页面，<span class="principal_content-blue">点击（系统和更新）</span>。</div>
    <img class="principal-img-1" src="../../public/image/index/96.png">

    <div class="principal_content step headline">2.在系统和更新页面<span class="principal_content-blue">点击方框内（纯净模式）页面</span>。</div>
    <img class="principal-img-1" src="../../public/image/index/95.png">

    <div class="principal_content step headline">3.在纯净模式页面<span class="principal_content-blue">点击下方（退出）按钮</span>。</div>
    <img class="principal-img-1" src="../../public/image/index/94.png">
W
    <div class="principal_content step headline">4.弹窗提示是否退出后<span class="principal_content-blue">点击（仍然退出）</span>，即可正常使用CC加速器下载安装任意游戏了。</div>
    <img class="principal-img-1" src="../../public/image/index/93.png">

    <div class="principal_content step headline"><span class="principal_content-blue">【方法2】</span>1.在CC加速器里下载好虫虫助手（任意游戏），点开安装页面提示无法安装，<span class="principal_content-blue">点击（了解纯净模式）</span>。</div>
    <img class="principal-img-1" src="../../public/image/index/92.png">

    <div class="principal_content step headline">2.此处为纯净模式介绍，<span class="principal_content-blue">点击下方（立即体验）</span>跳转关闭页。
    </div>
    <img class="principal-img-1" src="../../public/image/index/91.png">

    <div class="principal_content step headline">3.在纯净模式页面<span class="principal_content-blue">点击下方（退出）按钮</span>。</div>
    <img class="principal-img-1" src="../../public/image/index/94.png">

    <div class="principal_content step headline">4.弹窗提示是否退出后<span class="principal_content-blue">点击（仍然退出）</span>，即可正常使用CC加速器下载安装任意游戏了。
    </div>
    <img class="principal-img-1" src="../../public/image/index/93.png">

    <div class="principal_content">这就是2种鸿蒙系统纯净模式退出教程啦，大家快去试一试吧！</div>
  </div>
</div>
</template>

<script>
export default {
  name: 'Help_01',
  methods: {
    downloadAPK () {
      window.location.href = 'https://resource.ccspeed.cn/prd/42/20210409/47bfa20b-31fa-4008-9620-5adda1dab2ee.apk'
    },
    openOfficial () {
      window.location.href = 'https://m.ccspeed.cn/'
    },
    historyGo () {
      history.go(-1)
    }
  }
}
</script>
<style>
body{
  background: #161922;
}
*{
  font-family: Source Han Sans CN;
}
</style>
<style scoped lang="scss">
.header{
  height: 60px;
  background: #161922;
  display: flex;
  align-items: center;
  .logo{
    width: 42px;
    height: 42px;
    margin-left: 14px;
    margin-right: 7px;
  }
  .header-content{
    width: 220px;
    .header-title{
      font-size: 15px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #FFFFFF;
      margin-bottom: 2px;

      background: linear-gradient(0deg, #2992FF 0%, #00F2C2 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    .header-describe{
      font-size: 11px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #FFFFFF;
    }
  }
  .header-download{
    width: 70px;
    height: 28px;
    position: absolute;
    right: 14px;
  }
}
.navigation{
  height: 44px;
  background: #202632;
  display: flex;
  align-items: center;
  .navigation-img{
    width: 35px;
    height: 35px;
    border-radius: 50%;
    margin-left: 14px;
    margin-right: 10px;
  }
  .navigation-txt{
    font-size: 14px;
    font-weight: 400;
    color: #F1F1F1;
  }
}
.principal{
  margin-top: 20px;
  padding: 13px;
  padding-top: 0;
  font-size: 14px;
  line-height: 21px;
  .principal-headline1{
    font-weight: 500;
    color: #F1F1F1;
  }
  .principal_content{
    font-weight: 400;
    color: #68829E;
    margin-top: 17px;
    .principal_content-blue{
      color: #2992FF;
    }
  }
  .matter{
    line-height: 21px;
  }
  .step{
    color: #F1F1F1;
  }
  .principal-headline2{
    font-weight: 400;
    color: #2992FF;
    margin-top: 15px;
  }
  .principal-img-1{
    margin-top: 19px;
    width: 100%;
  }
  .principal-hint{
    margin-top: 18px;
    display: flex;
    align-items: center;
    .principal-hint-icon{
      width: 9px;
      height: 8px;
    }
    .principal-hint-txt{
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #68829E;
      margin-left: 4px;
    }
  }
}
.headline{
  line-height: 19px;
}
</style>
